import '../styles/Footer.css';
import React from 'react';

const FOOTER_ROUTES = [
  { name: 'Landing', href: '/' },
  { name: 'Login', href: '/login' },
  { name: 'Shipments', href: '/shipments' },
  { name: 'Track Shipment', href: '/track-shipment' },
  { name: 'Admin', href: '/admin' },
];

function currentPath() {
  if (typeof window === 'undefined' || !window.location) {
    return '';
  }
  return window.location.pathname || '';
}

function Footer() {
  const path = currentPath();

  return (
    <footer className="ff-footer" role="contentinfo" aria-label="Fast Forward Deliver Services">
      <div className="ff-footer__plate">
        <div className="ff-footer__lockup">
          <span className="ff-footer__pip" aria-hidden="true" />
          <div>
            <h2 className="ff-footer__wordmark">Fast Forward</h2>
            <span className="ff-footer__sublock">Deliver Services</span>
          </div>
        </div>

        <div className="ff-footer__identity">
          <p>
            Consignment shipments tracked from handover to delivery, with a waybill number,
            a route and a timestamp for every consignment.
          </p>
        </div>

        <nav className="ff-footer__nav" aria-label="Footer">
          <span className="ff-footer__nav-label">Service</span>
          <ul className="ff-footer__links">
            {FOOTER_ROUTES.map((route) => {
              const isActive = path === route.href;
              return (
                <li key={route.name}>
                  <a
                    className="ff-footer__link"
                    href={route.href}
                    aria-current={isActive ? 'page' : undefined}
                  >
                    {route.name}
                  </a>
                </li>
              );
            })}
          </ul>
        </nav>
      </div>

      <div className="ff-footer__baseline">
        <span>Fast Forward Deliver Services</span>
        <span className="ff-footer__ref">Consignment tracking instrument</span>
      </div>
    </footer>
  );
}

export default Footer;